import useAccountQuery from "@/shared/hooks/useAccountQuery";
import { PollResults } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";
import { getMockPollResults } from "./mock/pollVotesMock";

// A poll as the logged in customer sees it, with the results and their vote
const usePollResultsQuery = (pollId: number) => {
  const { data: account } = useAccountQuery();
  const userId = account?.item_id;

  return useQuery<PollResults>({
    queryKey: ["pollResults", pollId, userId],
    // TODO: replace with the real endpoint once it exists, e.g.
    // get2(`internal/secure/pos/v1/polls/${pollId}/results`)
    queryFn: () => getMockPollResults(pollId, userId),
    enabled: Number.isInteger(pollId) && userId !== undefined,
    retry: false,
  });
};

export default usePollResultsQuery;
